import React from 'react';
import {
    Box,

    Text,
    VStack,
    HStack,
    Progress,
    Tag,

} from '@chakra-ui/react';
import { formatNumber } from '../../../utils/DefaultFunction';


export const TemplateUsageByType = ({ data }) => {

    const renderColor=(type)=>{
        switch (type) {
            case "Authentication":
                return "#f97316"
            case "Transaction":
                return "#10b981"
            case "Informational":
                return "var(--brand-primary)"
            case "Marketing":
                return "#8b5cf6"
        
            default:
                return "#8b5cf6";
        }
    }
    return (
        <Box
            bg="white"
            p={6}
            borderRadius="lg"
            boxShadow="sm"
            border="1px solid"
            borderColor="gray.200"
        >
            <VStack align="stretch" spacing={4}>
                <Box>
                    <Text fontSize="lg" fontWeight="semibold" mb={1}>
                        Template Usage by Type
                    </Text>
                    <Text fontSize="sm" color="gray.600">
                        Message distribution across template categories
                    </Text>
                </Box>

                <VStack align="stretch" spacing={4} mt={4}>
                    {data.map((item) => (
                        <Box key={item.type_id}>
                            <HStack justify="space-between" mb={2}>
                                <HStack spacing={2}>
                                   
                                    <Box w="15px" h="15px" borderRadius="full" bg={renderColor(item.name)} />
                                    <Text fontSize="sm" fontWeight="medium">
                                        {item.name}
                                    </Text>
                                    <Tag fontSize="xx-small" color="black" bg={"white"} border={"1px solid #0000001a"} py={1}>
                                        {formatNumber(item.total_templates)} templates
                                    </Tag>
                                </HStack>
                                <Text fontSize="sm" fontWeight="semibold">
                                    {item.count.toLocaleString()}
                                </Text>
                            </HStack>
                            <Progress
                                value={item.percent}
                                size="md"
                                borderRadius="full"
                                bg="#e5e7eb"
                                mt={2}
                                sx={{
                                    "& > div": {
                                        backgroundColor: "var(--brand-primary)",
                                    },
                                }}

                            />
                            <Text fontSize="xs" color="gray.500" mt={1} textAlign="right">
                                {item.percent}% of total messages
                            </Text>
                        </Box>
                    ))}
                </VStack>
            </VStack>
        </Box>
    );
};